import { render, staticRenderFns } from "./ReleasePromotionalTextsEditPanelDialog.vue?vue&type=template&id=2f2f0512"
import script from "./ReleasePromotionalTextsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./ReleasePromotionalTextsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports